import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import "./PublicLayout.css";

export default function PublicLayout({
  children,
  prompt,
  actionText,
  actionTo,
}) {
  return (
    <div className="public-layout">
      <PublicHeader
        prompt={prompt}
        actionText={actionText}
        actionTo={actionTo}
      />

      {children}

      <PublicFooter />
    </div>
  );
}